import { render, staticRenderFns } from "./ClubDeductionsTable.vue?vue&type=template&id=b4495ec6&"
import script from "./ClubDeductionsTable.vue?vue&type=script&lang=js&"
export * from "./ClubDeductionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports